var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "app-container" }, [
        _c(
          "div",
          { staticClass: "outer" },
          [
            _c(
              "search-panel",
              {
                attrs: { flex: "", "show-btn": "", "is-entry": false },
                on: { getList: _vm.getListChange },
              },
              [
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("商品ID")]),
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        maxlength: 9,
                        size: "mini",
                        placeholder: "商品ID",
                      },
                      on: {
                        input: function ($event) {
                          _vm.id = _vm.id.replace(/[^\d]/g, "")
                        },
                      },
                      model: {
                        value: _vm.id,
                        callback: function ($$v) {
                          _vm.id = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "id",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("商品类目")]),
                    _c("ChangeCat", {
                      attrs: {
                        value: _vm.catList,
                        "show-only-agricultural": true,
                      },
                      on: { change: _vm.handleChange },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("商品状态")]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          size: "mini",
                          placeholder: "请选择商品状态",
                        },
                        model: {
                          value: _vm.publishState,
                          callback: function ($$v) {
                            _vm.publishState = $$v
                          },
                          expression: "publishState",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "未发布", value: 0 },
                        }),
                        _c("el-option", {
                          attrs: { label: "已发布", value: 1 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("商品名称")]),
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        size: "mini",
                        placeholder: "商品名称",
                      },
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("创建时间")]),
                    _c("el-date-picker", {
                      attrs: {
                        size: "mini",
                        type: "datetimerange",
                        align: "right",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                      },
                      model: {
                        value: _vm.timeData,
                        callback: function ($$v) {
                          _vm.timeData = $$v
                        },
                        expression: "timeData",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      slot: "button-right",
                      size: "mini",
                      type: "primary",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.operation("add")
                      },
                    },
                    slot: "button-right",
                  },
                  [_vm._v(" 新增商品 ")]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "table-container",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  "max-height": _vm.tabMaxHeight,
                  "highlight-current-row": "",
                  "header-cell-style": {
                    background: "#D9DDE1",
                    color: "#0D0202",
                    "font-weight": 400,
                    fontSize: "12px",
                  },
                  "row-key": "id",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    "reserve-selection": "",
                    selectable: _vm.checkboxT,
                    width: "55",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "id", label: "商品ID", width: "80" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: "商品名称",
                    "min-width": "250",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: "商品封面图",
                    "min-width": "81",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.coverImgUrl
                            ? _c("el-image", {
                                staticStyle: {
                                  width: "60px",
                                  "min-height": "60px",
                                },
                                attrs: {
                                  src: row.coverImgUrl.split(",")[0],
                                  "preview-src-list":
                                    row.coverImgUrl.split(","),
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "backGoryName",
                    label: "商品类目",
                    "min-width": "200",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "sellPrice", label: "商品价格" },
                }),
                _c("el-table-column", {
                  attrs: { label: "发布状态", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-color": "#13ce66",
                              "inactive-color": "#ff4949",
                            },
                            on: {
                              change: (e) => {
                                _vm.changeSwitch(e, scope.row, "publishState")
                              },
                            },
                            model: {
                              value: scope.row.publishState,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "publishState", $$v)
                              },
                              expression: "scope.row.publishState",
                            },
                          }),
                          _vm._v("   "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.publishState == 1
                                  ? "已发布"
                                  : "未发布"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "创建时间", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.createTime
                                    ? _vm.setTime(scope.row.createTime)
                                    : ""
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", fixed: "right", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.operation("show", scope.row)
                                },
                              },
                            },
                            [_vm._v(" 查看 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: scope.row.publishState == 1,
                                type: "text",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.operation("edit", scope.row)
                                },
                              },
                            },
                            [_vm._v(" 编辑 ")]
                          ),
                          _vm.NBYXSupplier.isNBYXSupplier !== true &&
                          !scope.row.isGoods &&
                          !scope.row.publishState &&
                          scope.row.hsgsOnSale != 1 &&
                          _vm.NBYXSupplier.isNBYXSupplier === false
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.operation(
                                        "syncToStore",
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 同步到店 ")]
                              )
                            : _vm._e(),
                          _vm.NBYXSupplier.isNBYXSupplier !== true
                            ? _c(
                                "el-button",
                                {
                                  style: {
                                    color: _vm.isShowSwitchCategory(scope.row)
                                      ? ""
                                      : "#1890ff",
                                  },
                                  attrs: {
                                    disabled: _vm.isShowSwitchCategory(
                                      scope.row
                                    ),
                                    type: "text",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.operation(
                                        "switchCategory",
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 切换类目 ")]
                              )
                            : _vm._e(),
                          scope.row.ancestryCategoryId == 2
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.operation("homeSet", scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 房源管理 ")]
                              )
                            : _vm._e(),
                          [9].includes(+scope.row.ancestryCategoryId)
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: scope.row.isOnSale === 1,
                                    type: "text",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.operation(
                                        "ticketSkuSet",
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 规格管理 ")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.operation("copy", scope.row)
                                },
                              },
                            },
                            [_vm._v(" 复制 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              style: {
                                color: scope.row.publishState == 1 ? "" : "red",
                              },
                              attrs: {
                                disabled: scope.row.publishState == 1,
                                type: "text",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.operation("delete", scope.row)
                                },
                              },
                            },
                            [_vm._v(" 删除 ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm.tableData && _vm.tableData.length > 0
              ? _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pagination.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pagination.nowPageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.pagination.count,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("ChangeStore", {
        attrs: {
          "show-change-store": _vm.showChangeStore,
          url: "/nb/goods/add",
        },
        on: {
          closeBox: function ($event) {
            _vm.showChangeStore = false
          },
        },
      }),
      _c("AddStock", {
        attrs: { "show-add-stock": _vm.showAddStock, "goods-id": _vm.goodsId },
        on: {
          "update:showAddStock": function ($event) {
            _vm.showAddStock = $event
          },
          "update:show-add-stock": function ($event) {
            _vm.showAddStock = $event
          },
          "update:goodsId": function ($event) {
            _vm.goodsId = $event
          },
          "update:goods-id": function ($event) {
            _vm.goodsId = $event
          },
          onSuccess: function ($event) {
            return _vm.getList()
          },
        },
      }),
      _c("set-state-dialog", {
        attrs: {
          "show-dialog": _vm.showSetHomeState,
          "set-home-type": _vm.setHomeType,
          "goods-list": _vm.checkGoodsList,
        },
        on: {
          "update:showDialog": function ($event) {
            _vm.showSetHomeState = $event
          },
          "update:show-dialog": function ($event) {
            _vm.showSetHomeState = $event
          },
        },
      }),
      _c("SelectGoodsType", {
        attrs: { show: _vm.showSelectType },
        on: {
          clear: function ($event) {
            _vm.showSelectType = false
          },
          submit: _vm.selectGoodsType,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }